/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cannabis_SeedsInputs */

const en_cannabis_seeds = /** @type {(inputs: Cannabis_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cannabis Seeds`)
};

const th_cannabis_seeds = /** @type {(inputs: Cannabis_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เมล็ดกัญชา`)
};

const ja_cannabis_seeds = /** @type {(inputs: Cannabis_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カンナビスシード`)
};

const fr_cannabis_seeds = /** @type {(inputs: Cannabis_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Graines de cannabis`)
};

const es_cannabis_seeds = /** @type {(inputs: Cannabis_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semillas de cannabis`)
};

const ru_cannabis_seeds = /** @type {(inputs: Cannabis_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Семена каннабиса`)
};

const zh_cannabis_seeds = /** @type {(inputs: Cannabis_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大麻种子`)
};

const vi_cannabis_seeds = /** @type {(inputs: Cannabis_SeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hạt giống cần sa`)
};

/**
* | output |
* | --- |
* | "Cannabis Seeds" |
*
* @param {Cannabis_SeedsInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const cannabis_seeds = /** @type {((inputs?: Cannabis_SeedsInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cannabis_SeedsInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_cannabis_seeds(inputs)
	if (locale === "ja") return ja_cannabis_seeds(inputs)
	if (locale === "fr") return fr_cannabis_seeds(inputs)
	if (locale === "es") return es_cannabis_seeds(inputs)
	if (locale === "ru") return ru_cannabis_seeds(inputs)
	if (locale === "zh") return zh_cannabis_seeds(inputs)
	if (locale === "vi") return vi_cannabis_seeds(inputs)
	return en_cannabis_seeds(inputs)
});